// extracted by mini-css-extract-plugin
module.exports = {"container":"AdNumber-module__container"};